import React from 'react';
import { PropTypes } from 'prop-types';
import { get } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import BaseTimelineEvent from 'common/Workqueue/BaseTimelineEvent';
import { getTimelineEventDetails } from 'common/Workqueue/timelineEventUtils';
import { buildTimelineEventDetailItems } from './enrollmentTimelineEventUtils';

const EnrollmentEditEvent = ({ timelineEvent }) => {
  const additionalData = get(timelineEvent, 'additional_data', {});
  const employeeName = get(additionalData, 'employee_name', 'System');
  const date = formatDate(timelineEvent.timestamp);
  const eventDetailItems = buildTimelineEventDetailItems(timelineEvent);

  if (eventDetailItems.length === 0) return null;

  return (
    <BaseTimelineEvent
      icon="IconPencil"
      message={`Edited by ${employeeName}`}
      date={date}
      eventDetails={getTimelineEventDetails(eventDetailItems, date)}
    />
  );
};

EnrollmentEditEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default EnrollmentEditEvent;
